import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-light" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center min-h-screen"
}
const _hoisted_3 = {
  key: 1,
  class: "max-w-4xl mx-auto px-4 py-8"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"18px"}
}, "arrow_back", -1)

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { usePublicCourseStore } from "@/stores/publicCourseStore";
import Spinner from "@/components/ui/Spinner.vue";
import Btn from "@/components/ui/Btn.vue";
import ChatbotUi from "@/components/ai/ChatbotUi.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicAITutor',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const publicCourseStore = usePublicCourseStore();

const loading = ref(true);
const slug = route.params.slug as string;
const courseId = computed(() => publicCourseStore.courseId ?? "");

onMounted(async () => {
	try {
		if (!publicCourseStore.courseId) {
			const courseData = await publicCourseStore.loadPublicCourse(slug);
			publicCourseStore.enrolledCourse = courseData.course;
		}
	} catch (err) {
		console.error("Failed to load course for AI tutor:", err);
	} finally {
		loading.value = false;
	}
});

const goBackToJourney = () => router.push(`/c/${slug}/journey`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Spinner, {
            size: "xl",
            variant: "primary"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Btn, {
              onClick: goBackToJourney,
              variant: "ghost",
              size: "sm",
              class: "flex items-center gap-1"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.back_to_journey")), 1)
              ]),
              _: 1
            })
          ]),
          (_unref(courseId))
            ? (_openBlock(), _createBlock(ChatbotUi, {
                key: 0,
                courseId: _unref(courseId),
                onClose: goBackToJourney
              }, null, 8, ["courseId"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})